import { FilterPanelProps } from '@aidkitorg/component-library';
import { FilterConfig } from '@aidkitorg/types/lib/admin-panel/filters';
import { useCallback, useMemo } from 'react';
import { useDashboardFilter } from '../contexts/DashboardFilterContext';

export const useDashboardFilterPanel = (storageKey: string): {
  filterPanelProps: Omit<FilterPanelProps, 'children'>;
  filterRef: React.MutableRefObject<any>;
} => {
  const {
    filterConfig,
    setFilterConfig,
    filterRef,
    availableFields,
    resetFilters
  } = useDashboardFilter();

  const handleFilterChange = useCallback((config: FilterConfig) => {
    setFilterConfig(config);
  }, [setFilterConfig]);

  const filterPanelProps: Omit<FilterPanelProps, 'children'> = useMemo(() => ({
    value: filterConfig,
    ref: filterRef,
    instanceId: storageKey,
    initialFilterConfig: filterConfig,
    availableFields,
    onFilterChange: handleFilterChange,
    onReset: resetFilters,
  }), [filterConfig, availableFields, handleFilterChange, resetFilters, storageKey]);

  return {
    filterPanelProps,
    filterRef
  };
};